import React from 'react';
import TextField from '@mui/material/TextField';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const TimeFild = ({ value, onChange, format = 'local' }) => {
    const pickerValue = React.useMemo(() => {
        if (!value) return null;
        const [hour, minute] = value.split(':');
        return format === 'utc'
            ? dayjs().utc().hour(+hour).minute(+minute)
            : dayjs().hour(+hour).minute(+minute);
    }, [value, format]);

    const handleChange = (newValue) => {
        if (!newValue || !dayjs(newValue).isValid()) {
            onChange('');
            return;
        }

        const timeStr = newValue.format('HH:mm'); // always send back in HH:mm
        onChange(timeStr);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
                value={pickerValue}
                onChange={handleChange}
                ampm={true}
                slotProps={{
                textField: {
                    fullWidth: true,
                    placeholder: 'hh:mm AM/PM', // force the exact text
                    InputProps: {
                        inputProps: {
                            placeholder: 'hh:mm AM/PM',
                        },
                    },
                },
            }}
            />
        </LocalizationProvider>
    );
};

export default TimeFild;
